import { render, staticRenderFns } from "./room.vue?vue&type=template&id=dd97ed58&"
import script from "./room.vue?vue&type=script&lang=ts&"
export * from "./room.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports